import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as menuActions from '../../../actions/menus';
import DeleteModal from '../DeleteModal';

const propTypes = {
  data: PropTypes.object.isRequired,
  deleteMenu: PropTypes.func.isRequired
};

const DeleteMenuModal = ({ data, deleteMenu, ...props }) => (
  <DeleteModal
    id="delete-menu-modal"
    title="Menu"
    itemTitle={data.title}
    deleteItem={() => deleteMenu(data.restaurantId, data.id)}
    {...props}
  />
);

DeleteMenuModal.propTypes = propTypes;

export default connect(
  null,
  menuActions
)(DeleteMenuModal);
